module.exports = __webpack_public_path__ + "static/media/arrowBack.5ea52341.svg";